/**
 * @param {AppConfig} appConfig
 */
const contactPhotoDirective = function (appConfig) {
    return {
        scope: {
            contact: '=',
            width: '@',
            height: '@',
        },
        restrict: 'E',
        template: function template() {
            return '<img ng-src="{{ getPhotoUrl() }}" alt="" title="" />';
        },
        controller: function controller($scope) {
            $scope.getPhotoUrl = function getPhotoUrl() {
                if ($scope.contact && ($scope.contact.hasPhoto() || $scope.contact.hasPhotoData())) {
                    if ($scope.contact.hasPhotoData()) {
                        return $scope.contact.photoData;
                    }
                    return appConfig.appUrl + $scope.contact.getPhotoPath($scope.width, $scope.height);
                }
                // Default image.
                return '/epos/img/default-member-photo.jpg';
            };
        },
    };
};

module.exports = contactPhotoDirective;
